// Same-origin API — nginx proxies /api/ to backend :5002
export const BASE_URL = "/api";
export const ITEMS_PER_PAGE = 9;
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
